import '../stylesheets/main.scss';

// Use what-input to track input method
import 'what-input';
import 'htmx.org';
// htmx initialization
// See https://htmx.org/docs/#webpack
import './init-htmx';
import 'htmx.org/dist/ext/multi-swap';

import 'core-js/modules/es.symbol';

import smoothscroll from 'smoothscroll-polyfill';

import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm';

import '../components/svg-sprite/javascripts';

import enableAnimations from './animation/enableAnimations';
import fixAnchorAnimations from './animation/fixAnchorAnimations';
import handleMailtoDecode from './animation/handleMailtoDecode';

// import initBrowserCheck from '../components/browser-check/javascript';
// import initDebugGrid from '../components/debug-grid/javascripts';
import initAccordion from '../components/accordion/javascripts';
import initBlockMedia from '../components/block-media/javascripts';
import initBusiness from '../components/business/javascripts';
import initChart from '../components/chart/javascripts';
import initContact from '../components/contact/javascripts';
import initFaqContainer from '../components/faq-container/javascripts';
import initFixingRates from '../components/fixing-rates/javascripts';
import initFooterTracking from '../components/footer/footerTracking';
import initForm from '../components/form/javascripts';
import initInvestmentAdvice from '../components/investment-advice/javascripts';
import initInvestorProfile from '../components/investor-profile/javascripts';
import initInxmail from '../components/inxmail/javascripts';
import initLocation from '../components/location/javascripts';
import initMenubar from '../components/menubar/javascripts';
import initModal from '../components/modal/javascripts';
import initMovingGradient from '../components/moving-gradient/javascripts';
import initNavigation from '../components/navigation/javascripts';
import initNotification from '../components/notification/javascripts';
import initPopup from '../components/popup/javascripts';
import initQuote from '../components/quote/javascripts';
import initScrollingText from '../components/scrolling-text/javascripts';
import initSearch from '../components/search/javascripts';
import initStageHome from '../components/stage-home/javascripts';
import initTabs from '../components/tabs/javascripts';
import initTeaserRowTracking from '../components/teaser-row/teaserRowTracking';
import initTombstones from '../components/tombstones/javascripts';
import initToolTip from '../components/tooltip/javascripts';
import initTopBtn from '../components/top-btn/javascripts';
import initVideo from '../components/video/javascripts';
import initGallery from '../components/gallery/javascripts';

// initialise smoothscroll polyfill!
smoothscroll.polyfill();

function enhancedDomReady(init) {
  window.addEventListener('DOMContentLoaded', init);
  window.addEventListener('reload', init);
}

enhancedDomReady(() => {
  // initBrowserCheck();
  // initDebugGrid();
  initAccordion();
  initBlockMedia();
  initBusiness();
  initChart();
  initContact();
  initFaqContainer();
  initFixingRates();
  initFooterTracking();
  initForm();
  initInvestmentAdvice();
  initInvestorProfile();
  initInxmail();
  initLocation();
  initMenubar();
  initModal();
  initMovingGradient();
  initNavigation();
  initNotification();
  initPopup();
  initQuote();
  initScrollingText();
  initSearch();
  initStageHome();
  initTabs();
  initTeaserRowTracking();
  initTombstones();
  initToolTip();
  initTopBtn();
  initVideo();
  initGallery();

  enableAnimations();
  fixAnchorAnimations();
  handleMailtoDecode();
});

// get full width without scrollbars for full width backgrounds inside containers..
new ResizeObserver(() => {
  const vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}).observe(document.documentElement);

// All links with target="_blank" attribute should have an attribute rel="noopener". This has performance and security reasons https://developers.google.com/web/tools/lighthouse/audits/noopener
const externalLinks = document.querySelectorAll("[target='_blank']");
if (externalLinks) {
  externalLinks.forEach((link) => {
    link.setAttribute('rel', 'noopener');
  });
}

const lightbox = new PhotoSwipeLightbox({
  gallery: 'body',
  children: 'a[data-pswp]',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  pswpModule: () => import('photoswipe')
});

lightbox.init();
